<template>
    <div>
        <pagamento
            v-show="mostrarPagamento"
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :temAcessoDetalharDespesa="$temAcessoView('DESP-GERAIS-FINAN-00')"
            :rotaDespesa="'DespesasGerais_Financeiro_Despesas_Detalhar'"
        >
            <template slot="footer">
                <app-btn-voltar
                    rota="DespesasGerais_Financeiro_Pagamentos"
                ></app-btn-voltar>
            </template>
        </pagamento>  
        <router-view
            v-if="pagamento"
            :pagamento="pagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></router-view>
    </div>
</template>

<script>
import Pagamento from '../../componentes/pagamentos/Pagamento.vue';
import PagamentosServicos from './PagamentosServicos.js'

export default {
    data() {
        return {
            pagamento: null
        }
    },
    
    components: {
        Pagamento
    },

    computed: {
        mostrarPagamento() {
            return this.$route.name === 'DespesasGerais_Financeiro_Pagamentos_Detalhar'
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.pagamento = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        }
    },

    created() {
        this.obterPagamento()
    }
}
</script>